import { render, staticRenderFns } from "./company-detail.vue?vue&type=template&id=d195eabc&"
import script from "./company-detail.vue?vue&type=script&lang=ts&"
export * from "./company-detail.vue?vue&type=script&lang=ts&"
import style0 from "./company-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports